import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { InputPhoneNumberComponent } from './component/input-phone-number/input-phone-number.component';
import { TextMaskModule } from 'angular2-text-mask';

@NgModule({
  imports: [
    CommonModule,
    TextMaskModule,
    ReactiveFormsModule
  ],
  declarations: [InputPhoneNumberComponent],
  exports: [InputPhoneNumberComponent]
})
export class PhoneNumberModule { }



// WEBPACK FOOTER //
// ./src/app/utils/phone-number/phone-number.module.ts